<child-header title="Update Finish" (closeEvent)="onNoClick()"></child-header>
<div mat-dialog-content style="font-size: 12px; width: 100%; padding: 13px 24px 0 24px; margin: 0;">
  <ng-container *ngFor="let finishSubscription of finishSubscriptions; let index = index">
    <table class="table vertical-align" *ngIf="finishSubscription.isUpdateSuccessful">
      <thead>
        <tr class="color-green">
          <th colspan="3" style="border-top: unset;">
            <div *ngIf="data?.type != 'Return'" style="white-space:normal;">
              The following subscription commitments have been updated in the Dicker
              Data Portal, until these changes have been successfully confirmed by Adobe you will not be billed
              for new services and the subscriptions will show on our portal with a pending status.
            </div>
            <div *ngIf="data?.type == 'Return'" style="white-space:normal;">
              The following subscription has been returned successfully
            </div>
          </th>
        </tr>
        <tr>
          <th>STOCK DESCRIPTION</th>
          <th>STOCK CODE</th>
          <th>QTY</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class='w200'>{{data?.confirmSubscriptions?.[index]?.subscriptionDescription}}</td>
          <td class='w200'>{{data?.confirmSubscriptions?.[index]?.stockCode }}</td>
          <td class='w200'>{{data?.type == 'Return' ? data?.confirmSubscriptions?.[index]?.cancelQty : data?.confirmSubscriptions?.[index]?.qty}}</td>
        </tr>
      </tbody>
    </table>
    <table id="subscriptionErrorTable" class="table" *ngIf="!finishSubscription.isUpdateSuccessful">
      <thead>
        <tr class="color-red">
          <th colspan="3">BELOW SUBSCRIPTION FAILED</th>
        </tr>
        <tr>
          <th>REFERENCE</th>
          <th>STOCK DESCRIPTION</th>
          <th>MESSAGE</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class='w200'>{{finishSubscription?.subscriptionDescription}}</td>
          <td class='w200'>{{finishSubscription?.stockDescription}}</td>
          <td class='w200'>{{finishSubscription?.message}}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>

</div>
<div mat-dialog-actions style="margin: 10px auto; display: block; max-width: 302px;">
  <button mat-button class="button button-red button-large" (click)="onNoClick()">OK</button>
</div>
